
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
@Component
export default class extends Vue {
  @Prop() info!: any;
  @Prop() index!: number;
  @Prop() type!: number;
  @Emit() deleteBlackItem() {
    console.log(this.type);

    this.$emit('deleteBlackItem', this.index, this.type);
  }
}
